import React from 'react';
import { FiFigma } from 'react-icons/fi';
import { BsCodeSlash } from 'react-icons/bs';
import { IoLogoNodejs } from 'react-icons/io';
import './global.css';

const Services = () => {
    return (
        <section className='mx-auto mt-5  overflow-hidden ' id='services'>
            <h1 className='text-warning text-center'>My Services</h1>
            <div className="small-border mb-4"></div>
            <div className='row gx-5 gy-5'>
                <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-right" data-aos-duration="2000">
                    <div className='shadow-lg bg-dark p-3 mb-3 mx-auto widthforrespo'>
                        <div className="heightforservice">
                            <div className='text-center mb-3 fs-1' style={{ color: "khaki" }}>
                                <FiFigma></FiFigma>
                            </div>
                            <h3 className='text-light text-center'>Figma To React</h3>
                            <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>I can do any figma file to convert it into a responsive, professional, and pixel-perfect React.js website. I am ready to use any npm packages or other CSS/UI frameworks by the project requirements.</p>

                        </div>
                    </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-up" data-aos-duration="2000">
                    <div className='bg-dark shadow-lg p-3 mb-3 mx-auto widthforrespo' >
                        <div className="heightforservice">
                            <div className='text-center mb-3 fs-1' style={{ color: "khaki" }}>
                                <BsCodeSlash></BsCodeSlash>
                            </div>
                            <h3 className='text-light text-center'>Frontend Development</h3>
                            <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>I am able to build a responsive website so that your website will look perfect on all the small and wide screens.I have almost 6 month of experience and complete almost 20+ projects.. I have good skills on HTML5, CSS3, BOOTSTRAP, Tailwind CSS, JAVASCRIPT, REACT JS .</p>

                        </div>
                    </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-4' data-aos="fade-left" data-aos-duration="2000">
                    <div className='bg-dark shadow-lg p-3 mb-3 mx-auto widthforrespo' >
                        <div className="heightforservice">
                            <div className='text-center mb-3 fs-1' style={{ color: "khaki" }}>
                                <IoLogoNodejs></IoLogoNodejs>
                            </div>
                            <h3 className='text-light text-center'>Backend Development</h3>
                            <p style={{ color: "whitesmoke", fontFamily: "poppins", lineHeight: "1.7rem" }}>I also have good hands-on experience about Mongodb , Express , Node Heroku . So i also build a MERN project .I am new to this portal but I will give you quality work. I am complete 5+ full-stack project .</p>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;